const ERROR_POSITION = {
    top: 'top',
    bottom: 'bottom',
};

export { ERROR_POSITION };
